const IconLock = ({ size, color, ...props }) => (
    <svg width={size} height={size} viewBox="0 0 11 15" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
        <path
            opacity="0.6"
            d="M9.39577 6.82383V4.25721C9.39577 2.06384 7.65412 0.290527 5.49997 0.290527C3.34583 0.290527 1.60418 2.06387 1.60418 4.25721V6.82383H0V14.2905H10.9999L11 6.82383H9.39577ZM6.12636 11.9572H4.85831V10.0905H6.12636V11.9572ZM7.99023 6.82383H3.00972V4.25721C3.00972 2.85726 4.12496 1.72162 5.5 1.72162C6.87493 1.72162 7.99028 2.85715 7.99028 4.25721L7.99023 6.82383Z"
            fill={color}
        />
    </svg>
);

export default IconLock;
